import { createContext, FunctionComponent, useContext, useState } from 'react';
import { MapboxProfile } from '@mapbox/mapbox-sdk/lib/classes/mapi-request';
import { Stop } from '../interfaces';
import { OmitMethods } from '../types';

interface ControllsContextI {
	profile: MapboxProfile;
	setProfile: (profile: MapboxProfile) => void;
	stops: Array<Stop>;
	setStops: (stops: Array<Stop>) => void;
}

const initialState: OmitMethods<ControllsContextI> = {
	profile: 'driving',
	stops: []
};

export const ControllsContext = createContext(initialState as ControllsContextI);

export const ControllsProvider: FunctionComponent = ({ children }) => {
	const [profile, setProfile] = useState<MapboxProfile>(initialState.profile);
	const [stops, setStops] = useState<Array<any>>(initialState.stops);
	return (
		<ControllsContext.Provider value={{ profile, setProfile, stops, setStops }}>
			{children}
		</ControllsContext.Provider>
	);
};

export function useControlls() {
	return useContext(ControllsContext);
}
